export const defaultConfig = {
  right: true,
  clipped: false,
  width: 1200,
  fixed: true,
  stateless: true,
  'hide-overlay': true,
  app: true,
  temporary: true,
};
